import { ifAuthenticated } from '@/router/before'

export const cttRouteNames = {
  RIDRoute: 'RIDRoute',
  InventionsRoute: 'InventionsRoute',
  TechSolutionsRoute: 'TechSolutionsRoute',
  PhotosRoute: 'CttPhotosRoute',
  NewsRoute: 'CttNewsRoute',
  ReferencesRoute: 'CttReferencesRoute'
}
const rn = cttRouteNames

export const cttRouteURLs = {
  [rn.RIDRoute]: '/rids',
  [rn.InventionsRoute]: '/inventions',
  [rn.TechSolutionsRoute]: '/tech-requests',
  [rn.PhotosRoute]: '/ctt-photos',
  [rn.NewsRoute]: '/ctt-news',
  [rn.ReferencesRoute]: '/ctt-references'
}

export const cttPages = [
  {
    path: cttRouteURLs[rn.RIDRoute],
    name: rn.RIDRoute,
    meta: {
      sidebar: {
        icon: ['fas', 'flask'],
        isDisplay: true
      },
      navbar: {
        group: 'ЦТТ',
        displayName: 'РИД'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "RidRoute" */ '@/views/ctt/RidRoute.vue')
  },
  {
    path: cttRouteURLs[rn.InventionsRoute],
    name: rn.InventionsRoute,
    meta: {
      sidebar: {
        icon: ['fas', 'boxes'],
        isDisplay: true
      },
      navbar: {
        group: 'ЦТТ',
        displayName: 'Разработки'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "RidRoute" */ '@/views/ctt/InventionsRoute.vue'
      )
  },
  {
    path: cttRouteURLs[rn.TechSolutionsRoute],
    name: rn.TechSolutionsRoute,
    meta: {
      sidebar: {
        icon: ['fas', 'microchip'],
        isDisplay: true
      },
      navbar: {
        group: 'ЦТТ',
        displayName: 'Технологические предложения'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "RidRoute" */ '@/views/ctt/TechOffersRoute.vue'
      )
  },
  {
    path: cttRouteURLs[rn.PhotosRoute],
    name: rn.PhotosRoute,
    meta: {
      sidebar: {
        icon: ['fas', 'images'],
        isDisplay: true
      },
      navbar: {
        group: 'ЦТТ',
        displayName: 'Фотографии'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "RidRoute" */ '@/views/ctt/PhotosRoute.vue')
  },
  {
    path: cttRouteURLs[rn.NewsRoute],
    name: rn.NewsRoute,
    meta: {
      sidebar: {
        icon: ['far', 'newspaper'],
        isDisplay: true
      },
      navbar: {
        group: 'ЦТТ',
        displayName: 'Новости'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "RidRoute" */ '@/views/ctt/NewsRoute.vue')
  },
  {
    path: cttRouteURLs[rn.ReferencesRoute],
    name: rn.ReferencesRoute,
    meta: {
      sidebar: {
        icon: ['fas', 'book'],
        isDisplay: true
      },
      navbar: {
        group: 'ЦТТ',
        displayName: 'Справочники'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "RidRoute" */ '@/views/ctt/ReferencesRoute.vue'
      )
  }
]
